import { render, staticRenderFns } from "./excavate_factor.vue?vue&type=template&id=1f2de949&scoped=true"
import script from "./excavate_factor.vue?vue&type=script&lang=js"
export * from "./excavate_factor.vue?vue&type=script&lang=js"
import style0 from "./excavate_factor.vue?vue&type=style&index=0&id=1f2de949&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2de949",
  null
  
)

export default component.exports